<template>
  <div>
    <a href="#" @click="goback()">&lt;Terug naar toernooidashboard</a>
  <div class="details w3-theme-l2">
    <div>Tournament: {{tournament.name}}</div>
    <div>Ronde: {{ $route.params.roundId }}</div>
  </div>
    <!-- als er groepen zijn, dan weergeven per groep, anders alleen groep 0 zonder titel -->
    <div>Matches:</div>
      <div v-for="group in tournament.groups"
           :key="group.groupId"
           :group="group">
        <div>Group: {{group.name}}</div>   
        <table class="tblFull"><tbody>
        <tr><td>White</td><td></td><td>Black</td><td>Result</td><td>Actions</td></tr>
        <tr class="round" v-for="(match, index) in groupMatches(group.groupId)"
                                  :key="match.matchId" 
                                  :match="match">
            <td>{{match.whitePlayer.person.name}}</td>
            <td> - </td>
            <td>{{match.blackPlayer.person.name}}</td>
            <td>
              <select v-model="match.result" :key="index" v-on:change="setMatchresult(index)"> 
                <option :value="0"></option>
                <option :value="1">1-0</option>
                <option :value="2">0-1</option>
                <option :value="3">1/2-1/2</option>
              </select>
            </td>
          <td class="lastCol"><a class="imgbtn" href="#" title="delete this match"  @click="deleteMatch(match.matchId)"><font-awesome-icon icon="trash" /></a></td>
        </tr>
        </tbody></table>
      </div>
    </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';

export default {
  name: 'RoundDetails',
  props: {
    roundId: String,
    tournamentId: String
  },
  data: function () {
    return {
      tournament: {tournamentId:-1, name:''},
      matches: [],
    }
  },
  beforeMount() {
    this.loadMatches();
    this.loadTournament();
    this.loadGroups();
  },
  methods: {
    groupMatches: function(groupId) {
      return this.matches.filter(m => m.groupId == groupId);
    },
    
    deleteMatch: function(matchId) {
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false,
      };
      let path = '/match/' + matchId;
      let that = this;
      console.log('Deleting match: ' + matchId);
      RestAPI
        .del(apiName, path, myInit)
        .then(response => {
          console.log('Succes.' + response);
          that.loadMatches();
        })
        .catch(error => {
          console.log(error.response);
        });
        
      console.log('Match deleted.');
    },

    goback: function() {
      this.$router.go(-2);
    },

    loadGroups: function() { //Can only be called after loadTournament
      const myInit = { 
        response: false
      };
      let completePath = '/tournament/' + this.$route.params.tournamentId + '/group';
      let that = this;
      console.log ("pad: " + completePath);
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.tournament.groups = response;
          console.log ("groups loaded: " + that.tournament.groups.count);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadTournament: function() {
      const myInit = { 
        response: false
      };
      let completePath = '/tournament/' + this.$route.params.tournamentId;
      let that = this;
      console.log ("pad: " + completePath);
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.tournament = response;
          console.log ("tournament loaded: " + that.tournament);
          console.log ("Group count " + that.tournament.groups);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadMatches: function() {
      const myInit = { 
        response: false,
      };
      let that = this;
      let completePath = '/match?roundId=' + this.$route.params.roundId;
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.matches = response;
          console.log ("matches loaded: " + that.matches);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    setMatchresult: function(matchIndex) {
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.matches[matchIndex],
        response: false
      };
      let completePath = '/match/' + this.matches[matchIndex].matchId;
      RestAPI
        .put(apiName, completePath, myInit)
        .then(response => {
          console.log ("match updated: " + response);
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    }
  }
}
</script>

<style scoped>


/* mobile */
@media screen and (max-width: 600px) {

  header {
    font-size: 5vw;
    padding: 2vw;
  }

  .details {
    padding: 2vw;
  }

}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {

  header {
    font-size: 1.5vw;
    padding: 1vw;
  }

  .details {
    padding: 1vw;
  }

}

/* laptop */
@media screen and (min-width: 1281px) {

  header {
    font-size: 1.5vw;
    padding: 1vw;
  }

  .details {
    padding: 1vw;
  }

}

</style>
